<template>
  <div>    
    <div class="form-group">
       <multiselect 
        v-model="valorDefinido"
        :id="idDelInput"
        :value="tipo.Id"
        :options="Anexos"
        select-label=""           
        :show-labels="false"
        :placeholder="placeholder"
        @select="cambioAnexo"
        label="Nombre"
        @search-change="updateSearchText"
       >
        <span slot="noResult" @click="agregaElemento">Doble Click Para Agregar</span>
      </multiselect>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import Multiselect from 'vue-multiselect'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default
  {
    components:{Multiselect},
    data(){
      return {
        enumeraciones,
        comun,
        Anexos:[],
        desHabilitaEdicion:true,
        idDelModelo: null,
        searchText: '',
        valorDefinido: Number,
      }
    },//Data
    props: {
      prefijo: Number,
      parametros: Object,
      placeholder: String, 
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String
    },
    mounted() {
       if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogos_Establecer051Anexo", parametros);
    },
    methods: {
    CargarCatalogoDeAnexos(){
      let peticion = {
        EsPrueba: comun.EsPrueba
      }
      axios.post(api.conexion + api.PJ.catalogos.C051Anexos, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Anexos = respuesta.data.anexos;
              return respuesta.data.anexos;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });
    },//CargarCatalogoDeAnexos
    agregaElemento:function(e){
      var AId = this.Anexos.length;
      var Nom = this.searchText;
      var AIde = AId;
      this.Anexos.push({AnexoId:AId, Nombre:Nom, AnexoId_Equitas:AIde});
    },
    updateSearchText(query) {
        this.searchText = query;
    },
    cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogos_Establecer051Anexo", parametros);
        this.$emit("valorParaElPadre", evento);
      },
      cambioAnexo (evento) {
        this.$emit("valorParaElPadre", evento);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeAnexos();
    }
  }

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/components/PJ/Catalogos/051Anexos.vue